import { SET_CREATE_COURSE_ERRORS } from '../constants';

const initialState = {
  errors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CREATE_COURSE_ERRORS:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
